import React from 'react';

const TextInput = ({
    name,
    placeholder = '',
    type = 'text',
    value,
    onChange,
    error = '',
    required = false,
    className = '',
    readOnly = false,
    autoComplete = 'off',
    ...rest
}) => {
    return (
        <div className={`w-full ${className}`}>
            <input
                name={name}
                type={type}
                placeholder={placeholder}
                autoComplete={autoComplete}
                value={value}
                onChange={onChange}
                required={required}
                readOnly={readOnly}
                className={`w-full px-0 py-2 text-gray-900 bg-transparent border-0 border-b border-gray-300  focus:outline-none focus:ring-0
                    ${error ? 'border-red-500' : 'border-gray-300'} 
                    `}
                {...rest}
            />
            {error && <p className='mt-1 text-xs text-red-500'>{error}</p>}
        </div>
    );
};

export default TextInput;
